
<div class="competitive-analysis-popup container" fxLayout="column" fxLayoutGap="15px">
  <form [formGroup]="form" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
    <mtn-key-indicator-field [form]="form"></mtn-key-indicator-field>
    <mtn-comparison-type-field [form]="form"></mtn-comparison-type-field>
    <mtn-region-field [form]="form" [isMarketAreaAvailable]="!!marketArea?.getFeature()"></mtn-region-field>
    <mtn-drive-time-minutes-field [form]="form"
                                  *ngIf="form.get('region').value === RegionType.DRIVE_TIME"></mtn-drive-time-minutes-field>
    <mtn-ring-miles-field [form]="form"
                          *ngIf="form.get('region').value === RegionType.RING"></mtn-ring-miles-field>
  </form>

  <!-- Chart View -->
  <div *ngIf="isChartView && !isLoading && ranking && comparison?.isChartable(); else chartViewElse">
    <div class="widget-container container" fxLayout="row" fxLayoutAlign="center start" fxLayoutGap="15px">

      <!-- ✅ SVG Circular Progress -->
      <div class="chart-container">
        <div class="circular-progress">
          <svg width="100" height="100" viewBox="0 0 100 100">
            <!-- Background circle -->
            <circle cx="50" cy="50" r="40"
                    fill="none"
                    stroke="rgba(255,255,255,0.1)"
                    stroke-width="12"/>

            <!-- Progress circle -->
            <circle cx="50" cy="50" r="40"
                    fill="none"
                    [attr.stroke]="color"
                    stroke-width="12"
                    stroke-linecap="square"
                    [style.stroke-dasharray]="strokeDasharray"
                    [style.stroke-dashoffset]="strokeDashoffset"
                    transform="rotate(-90 50 50)"/>
          </svg>

          <!-- Percentage text -->
          <div class="percentage-text" fxLayout="row" fxLayoutAlign="center center">
            <span>{{ranking.percentile}}%</span>
          </div>
        </div>
      </div>

      <!-- Text descriptors -->
      <div class="descriptor-container" fxLayout="column" fxLayoutAlign="space-between ">
        <h2 class="mat-h2 text-small-caps no-bottom-margin">
          {{rankingDescriptor}} {{rankingGroupDescriptor}} {{rankingTypeDescriptor}}
        </h2>
        <small class="color-muted" *ngIf="labelRegion">
          {{'VS_LABEL' | translate}} {{labelComparisonType}} {{'IN_LABEL' | translate}} {{labelRegion}}
        </small>
        <div fxFlex></div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span class="color-muted">
            {{'RANK_LABEL' | translate}} {{ranking.rank}} {{'OF_LABEL' | translate}} {{comparison.getFilteredRankings().length}} {{'STORES_LABEL' | translate}}
          </span>
          <fa-icon icon="exclamation-triangle" style="color:orange"
                   *ngIf="comparison.rankings.length > comparison.getFilteredRankings().length"
                   matTooltipClass="multiline-tooltip" [matTooltip]="excludedStoresTooltip"></fa-icon>
        </div>
      </div>
    </div>

    <!-- Number Line Chart Section -->
    <div fxLayout="column" fxLayoutGap="15px">
      <h3 class="mat-h3 text-small-caps">{{'COMPETITIVE_DISTRIBUTION' | translate}}</h3>
      <div class="number-line-chart-container container" *ngFor="let dataset of datasets">
        <mtn-number-line-chart [dataset]="dataset" [axisBuilder]="numberChartAxisBuilder"
                               [showAxis]="true"></mtn-number-line-chart>
        <mtn-restricted-license-overlay *ngIf="wizard.model.isRestrictedLicenseOverlayEnabled"
                                        [bannerSize]="Size.SMALL"
                                        [buttonSize]="Size.SMALL"></mtn-restricted-license-overlay>
      </div>
    </div>
  </div>

   <div *ngIf="!isChartView" class="data-table">
      <div class="table-container">
        <div class="table-body">

          <!-- Sticky Header -->
          <div class="table-header">
            <div class="header-cell rank-cell">Rank</div>
            <div class="header-cell location-cell">Location Name<br/>and Address</div>
            <div class="header-cell sales-cell">Weekly Estimated<br/>Sales{{ form.get('keyIndicator')?.value === 'SALES_VOLUME' ? ' Volume' : '/SQFT'}}</div>
            <div class="header-cell fit-cell">Store FIT<br/>Category</div>
            <div class="header-cell size-cell">Store Size<br/>(Total SQFT)</div>
            <div class="header-cell distance-cell">Distance<br/>(Miles)</div>
            <div class="header-cell percent-cell">% Sales vs<br/>Avg Market</div>
          </div>

          <!-- Loading State -->
          <div class="table-loading-state" *ngIf="isLoading || tableData === null">
            <mtn-spinner [on]="true" [size]="SpinnerSize.MEDIUM"></mtn-spinner>
            <p class="loading-text">Loading ranking data...</p>
          </div>

          <!-- Empty State -->
          <div class="table-empty-state" *ngIf="!isLoading && tableData !== null && tableData.length === 0">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 9V13M12 17H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                    stroke="rgba(255, 255, 255, 0.4)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p class="empty-text">No ranking data available</p>
            <p class="empty-subtext">Try adjusting your filters or check back later</p>
          </div>

          <!-- Data Rows -->
          <ng-container *ngIf="!isLoading && tableData !== null && tableData.length > 0">
            <div class="table-row" *ngFor="let item of tableData">
              <div class="table-cell rank-cell">{{ item.rank }}</div>
              <div class="table-cell location-cell">
                <div class="location-name">{{ item.name }}</div>
                <div class="location-address">{{ item.address }}</div>
              </div>
              <div class="table-cell sales-cell">{{ item.salesVolume }}</div>
              <div class="table-cell fit-cell">{{ item.fitCategory }}</div>
              <div class="table-cell size-cell">{{ item.size }}</div>
              <div class="table-cell distance-cell">{{ item.distance }}</div>
              <div class="table-cell percent-cell">{{ item.salesVsMarket }}</div>
            </div>
          </ng-container>

        </div>
      </div>
    </div>

  <!-- Chart View Else (Loading or Not Chartable) -->
  <ng-template #chartViewElse>
    <div *ngIf="isChartView">
      <!-- Loading state for chart view -->
      <div *ngIf="isLoading" class="chart-loading-container" fxLayout="column" fxLayoutAlign="center center">
        <mtn-spinner [on]="true" [size]="SpinnerSize.LARGE"></mtn-spinner>
        <p class="loading-text">Loading ranking data...</p>
      </div>
      <!-- Not chartable message -->
      <div *ngIf="!isLoading && comparison" class="color-muted">{{comparison.unchartableReason}}</div>
      <!-- No data message -->
      <div *ngIf="!isLoading && !comparison && !ranking" class="color-muted">No ranking data available</div>
    </div>
  </ng-template>
</div>

